import React from 'react';
interface Props {
  currentShipmentStatus: string;
}
function QuickUserNav({ currentShipmentStatus }: Props) {
  let packagesActive = currentShipmentStatus !== 'DetailForm';
  let ratesActive = packagesActive && currentShipmentStatus !== 'SettingForm';
  let onRoute = currentShipmentStatus === 'DetailForm';
  let onPackage = currentShipmentStatus === 'SettingForm';
  return (
    <div className='row mt-4 mb-3 w-full'>
      {/* <div className='col-sm-1'></div> */}
      <div className='w-full mx-2 text-center'>
        <div className='row'>
          <div className='col-sm-12 col-md-6 ps-1 pe-1'>
            <h3
              className={
                onRoute
                  ? 'boldstepperhead text-start'
                  : 'steppertext ubbe-blue text-start'
              }
              id='route_label'
            >
              Step 1
            </h3>
            <div className={`${packagesActive && 'stepperBg'} progress`}>
              <div
                className={`${packagesActive && 'stepperBg'} progress`}
                role='progressbar'
                id='route_progress'
                style={{ width: '100%' }}
              ></div>
            </div>

            <div className={onRoute ? 'form-check activecheckedhead' : 'round'}>
              {!onRoute ? (
                <>
                  <input
                    type='checkbox'
                    id='checkbox'
                    checked={packagesActive}
                  />
                  <label htmlFor='checkbox'></label>
                  <div className='boldsteppertext'>User Details</div>
                </>
              ) : (
                <div className='mt-2'>
                  <input
                    className='form-check-input activechecked '
                    type='radio'
                    name='flexRadioDefault'
                    id='flexRadioDefault2'
                    checked
                  />
                  <div className='boldsteppertext'>User Details</div>
                </div>
              )}
            </div>
          </div>
          <div className='col-sm-12 col-md-6 ps-1 pe-1 text-center'>
            <h3
              className={
                onPackage
                  ? 'boldstepperhead text-start'
                  : 'steppertext ubbe-blue text-start'
              }
              id='packages_label'
            >
              Step 2
            </h3>
            <div className={`${onPackage && 'stepperBg'} progress`}>
              <div
                className={`${onPackage && 'stepperBg'} progress-bar`}
                role='progressbar'
                id='packages_progress'
                style={{ width: '0' }}
              ></div>
            </div>

            <div
              className={onPackage ? 'form-check activecheckedhead' : 'round'}
            >
              {onRoute ? (
                <>
                  <input
                    type='checkbox'
                    id='checkbox'
                    checked={ratesActive}
                  />
                  <label htmlFor='checkbox'></label>
                  <div
                    className={
                      packagesActive ? 'boldsteppertext' : 'normalsteppertext'
                    }
                  >
                    Optional Settings
                  </div>
                </>
              ) : (
                <div className='d-flex  gap-2 '>
                  <input
                    className='form-check-input activechecked '
                    type='radio'
                    name='flexRadioDefault'
                    id='flexRadioDefault2'
                    checked
                  />
                  <div
                    className={
                      packagesActive ? 'boldsteppertext' : 'normalsteppertext'
                    }
                  >
                    Optional Settings
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className='col-sm-1'></div>
    </div>
  );
}

export default QuickUserNav;
